<template>
  <modal
    class="addNewRetainershipModal"
    name="addGPMModal"
    transition="pop-out"
    :width="modalWidth"
    :height="500"
    @closed="closed"
    @opened="opened"
  >
    <div class="retainership__box">
      <button
        type="button"
        class="close modal-close"
        aria-label="Close"
        @click="closed"
      >
        <span aria-hidden="true">&times;</span>
      </button>
      <div class="text-center">
        <h3 class="mt-2 add__retainership__header">
          <span>
            <img src="@/assets/img/deal.png" width="50px" />
          </span>
          <span v-if="!this.$route.query.companyID">{{
            $t("text.gManagement.addCompanyGroup")
          }}</span>
          <span v-else>{{ $t("text.gManagement.addIndustryGroup") }}</span>
        </h3>

        <div class="sign_up_form_section">
          <form>
            <!-- <div class="col-md-6"> -->
            <div class="mt-3 form_input_section">
              <div class="input__block" ref="phone_input_div">
                <input
                  type="text"
                  placeholder="Name"
                  class="form-control w-100"
                  v-model="name"
                />
              </div>
            </div>
            <div class="mt-3 form_input_section">
              <div class="input__block" ref="phone_input_div">
                <input
                  type="email"
                  placeholder="Email"
                  class="form-control w-100"
                  v-model="email"
                />
              </div>
            </div>
            <!-- </div> -->

            <div class="mt-3 form_input_section">
              <div class="input__block" ref="phone_input_div">
                <input
                  type="text"
                  placeholder="Description"
                  class="form-control w-100"
                  v-model="description"
                />
              </div>
            </div>

            <!-- <div class="mt-3">
              <label>Owner</label>
              <div class="input__block">
                <select v-model="ownerId">
                  <option selected disabled>Select Owner</option>
                  <option
                    :value="owner.id"
                    v-for="(owner, index) in companyBDList"
                    :key="index"
                  >
                    <span>
                      {{ owner.name }}
                    </span>
                  </option>
                </select>
              </div>
            </div> -->

            <div
              class="mt-3 form_input_section"
              v-if="!this.$route.query.companyID"
            >
              <div class="mt-3 input__block">
                <select v-model="category">
                  <option value="selectCategory" selected disabled>
                    {{ $t("text.gManagement.selectCategory") }}
                  </option>
                  <option
                    :value="category.name"
                    v-for="(category, index) in categoryList"
                    :key="index"
                  >
                    <span>
                      {{ category.name }}
                    </span>
                  </option>
                </select>
              </div>
            </div>

            <div class="mt-5 text-center">
              <button
                class="btn dealers_btn"
                @click="addGPM"
                :disabled="isButtonDisabled ? true : null"
                :style="[
                  isButtonDisabled
                    ? { cursor: 'not-allowed' }
                    : { cursor: 'pointer' },
                ]"
              >
                {{ $t("text.gManagement.addGroup") }}
                <img
                  src="@/assets/img/git_loader.gif"
                  style="display: none"
                  width="19px"
                  class="ml-3 loader"
                />
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </modal>
</template>
<script>
const MODAL_WIDTH = 700;
import configObject from "@/config";
import JQuery from "jquery";
let $ = JQuery;

export default {
  name: "addGPMModal",
  props: ["companyId"],
  data() {
    return {
      modalWidth: MODAL_WIDTH,
      isButtonDisabled: false,
      showLoader: false,
      name: "",
      email: "",
      description: "",
      category: "selectCategory",
      categoryList: [],
    };
  },
  // watch: {
  //   companyId(oldValue, newValue) {
  //     this.getCompanyBranchDealers();
  //   },
  // },
  created() {
    this.modalWidth =
      window.innerWidth < MODAL_WIDTH ? MODAL_WIDTH / 2 : MODAL_WIDTH;
  },
  methods: {
    opened() {
      if (!this.$route.query.companyID) {
        this.getCategories();
      }

      // this.getCompanies();
    },
    closed() {
      (this.email = null),
        (this.description = null),
        (this.category = null),
        (this.event = null),
        this.$modal.hide("addGPMModal");
    },

    getCategories() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Role/GroupCategories/EPUMP`,
          configObject.authConfig()
        )
        .then((response) => {
          const namesToFilter = ["Team", "Sales Rep", "Regional Engineer"];

          const filteredItems = response.data.filter((item) =>
            namesToFilter.includes(item.name)
          );

          this.categoryList = filteredItems;
        })
        .catch((error) => {
          // this.showLoader = false;
        });
    },

    addGPM(event) {
      event.preventDefault();
      if (!this.name) {
        this.$toast.open({
          message: this.$t("text.gManagement.inputName"),
          type: "error",
          duration: 3000,
        });
        return;
      }
      if (!this.email) {
        this.$toast.open({
          message: this.$t("text.gManagement.inputEmail"),
          type: "error",
          duration: 3000,
        });
        return;
      }
      if (!this.description) {
        this.$toast.open({
          message: this.$t("text.gManagement.inputDesc"),
          type: "error",
          duration: 3000,
        });
        return;
      }
      if (this.$route.query.companyId && !this.category) {
        this.$toast.open({
          message: this.$t("text.gManagement.chooseCategory"),
          type: "error",
          duration: 3000,
        });
        return;
      }

      const data = {
        name: this.name,
        description: this.description,
        category: this.$route.query.companyID ? "Group" : this.category,
        email: this.email,
        companyId: this.companyId,
      };
      $(".loader").show();
      this.isButtonDisabled = true;

      this.axios
        .post(
          `${configObject.apiBaseUrl}/GroupManagement/PostGroup`,
          data,
          configObject.authConfig()
        )
        .then((res) => {
          this.$toast.open({
            message: this.$t("text.gManagement.groupCreated"),
            type: "success",
            duration: 3000,
          });
          $(".loader").hide();
          this.isButtonDisabled = false;
          this.email = "";
          this.phoneNumber = "";
          this.category = "";
          this.name = "";
          this.$modal.hide("addGPMModal");
          this.$eventHub.$emit("getGPM");
        })
        .catch((error) => {
          this.isButtonDisabled = false;
          $(".loader").hide();
          this.$toast.open({
            message: error.response.data.message,
            type: "error",
            duration: 3000,
          });
        });
    },
  },
};
</script>
